import React from 'react';

import { Label, Select, Flex } from '@lucidhq/lucidium';
import { useField } from '@lucidhq/lucidium/components/FormV2';

import { t } from '~/utils/i18n';

export type CreativesNumberOption = {
  label: string;
  value: number;
};

export const creativesNumberOptions: CreativesNumberOption[] = [
  {
    label: '1',
    value: 1
  },
  {
    label: '2',
    value: 2
  },
  {
    label: '3',
    value: 3
  },
  {
    label: '4',
    value: 4
  }
];

type CreativesNumberFieldProps = {
  name: string;
  readOnly?: boolean;
};

export const CreativesNumberField: React.FC<CreativesNumberFieldProps> = ({
  name,
  readOnly = false // @TODO (lesgrosman) Figure out if it can be disabled
}) => {
  const [field, meta, helpers] = useField(name);

  return (
    <Flex lss={{ flexDirection: 'column' }}>
      <Label lss={{ my: 'md' }} htmlFor={name} required>
        {t(`forms.labels.creativesNumber`)}
      </Label>

      <Select
        data-testid="creative-numbers-field"
        required
        name={field.name}
        value={field.value}
        error={meta.error}
        disabled={readOnly}
        placeholder={t(`forms.placeholders.creativesNumber`)}
        labelKey="label"
        valueKey="value"
        options={creativesNumberOptions}
        onChange={(option: any) => {
          helpers.setValue(option, false);
        }}
      />
    </Flex>
  );
};
